<template>
  <div id="accountCreation">

<!--    <template v-if="!User.token">-->
      <AccountCreationMobile :account="account"
                             :back="back" :send="send"
                             v-show="!$store.state.isDesktop"
                             ref="accountCreationMobile"
      ></AccountCreationMobile>

      <AccountCreationDesktop :account="account"
                              :back="back" :send="send"
                              v-show="$store.state.isDesktop"
                              ref="accountCreationDesktop"
      ></AccountCreationDesktop>
<!--    </template>-->

<!--    <template v-if="User.token">-->
<!--      -->
<!--    </template>-->


  </div>
</template>

<script>

  import Axios from 'axios';
  import AccountCreationMobile from '@/components/mobile/AccountCreation';
  import AccountCreationDesktop from '@/components/desktop/AccountCreation';
  import User from '../../core/User';

  export default {

    name: "accountCreation",

    components: {
      AccountCreationMobile,
      AccountCreationDesktop
    },

    data() {
      return {
        account: {
          name: "",
          address: "",
          unit: "",
          phone: "",
          note: ""
        },
        User
      };
    },

    mounted() {
      this.$store.commit("setDisplay", {
        showHeader: true,
        showHeaderLeft: true,
        showFooter: true,
        headerTitle: "account_creation.title",
        headerIcon: "/svg/history.svg"
      });
    },

    methods: {

      back() {
        history.back();
      },
      checkFormValidity() {
        return (this.$store.state.isDesktop ?
                !this.$refs.accountCreationDesktop.$validate.valid()
                : !this.$refs.accountCreationMobile.$validate.valid())
      },
      async send() {
        if (this.checkFormValidity()) {
          showAffirmation("Erreur", "Veuillez compléter le formulaire.");
          return;
        }
        showSpinner();
        let data = {
          name: this.account.name,
          address: this.account.address,
          unit: this.account.unit,
          phone: this.account.phone,
          note: this.account.note,
          property: this.$store.state.property
        };
        let result = await Axios.get(CONFIG.urlServer + "/api/properties_search", {
          params: {
            address: this.account.address,
            hopemSync: true
          }
        }).catch(() => {
          hideSpinner();
        });
        if (result.status != 200) {
          showAffirmation(this.$t("error"), this.$t("account_creation.error.form"));
          hideSpinner();
          return;
        }
        if (result.data.data.length == 0) {
          showAffirmation(this.$t("error"), this.$t("account_creation.error.address"));
          hideSpinner();
          return;
        }
        let create = await Axios.post(CONFIG.urlServer + "/api/account_requests", data);
        if (create.status != 200) {
          showAffirmation(this.$t("error"), this.$t("account_creation.error.generic"));
          hideSpinner();
          return;
        }
        hideSpinner();
        await showAffirmation(this.$t("success"), this.$t("account_creation.received"));
        this.$router.push("/home");
      }

    }

  }

</script>

<style lang="scss" scoped>

  #accountCreation {
    background-color: #f2f3f4;
    display: flex;
  }

</style>